import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class ChatbotService {

  private clearChatSubject = new BehaviorSubject<boolean>(false); 
  private openChatSubject = new BehaviorSubject<boolean>(false); 



  constructor(
    private httpClient: HttpClient,
    private authService: AuthService
  ) { }
  getClearchatEVent(): Observable<boolean> {
    return this.clearChatSubject.asObservable();
  }
  clearChat() {
    this.clearChatSubject.next(true);
  }

  getOpenchatEVent(): Observable<boolean> {
    return this.openChatSubject.asObservable();
  }
  
  openChat(value = false){
     this.openChatSubject.next(value);
  }


masterChat(data: any, env: string): Observable<string> {
  const url = env === "dev" ? `${environment.chatAPi}/conversation` : `${environment.uatchatAPI}/conversation`;
  const user = this.authService.getUser;
  const headers: Record<string, string> = {
    "Content-Type": "application/json"
  };
  if (user?.accessToken) {
    headers["xaccesstoken"] = user.accessToken;
  }

  return new Observable<string>(observer => {
    fetch(url, {
      method: "POST",
      headers,
      body: JSON.stringify(data)
    }).then(async response => {
      if (!response.ok) {
        const errorBody = await response.text(); 
        observer.error({
          status: response.status,
          statusText: response.statusText,
          body: errorBody
        });
        return;
      }

      const reader = response.body!.getReader();
      const decoder = new TextDecoder();
      let done = false;

      while (!done) {
        const { value, done: doneReading } = await reader.read();
        done = doneReading;
        const chunk = decoder.decode(value, { stream: true });
        observer.next(chunk);
      }

      observer.complete();
    }).catch(err => {
      observer.error({
        status: 0,
        statusText: 'Network or CORS error',
        error: err
      });
    });
  });
}



  downloadCsv(data, env) {
    const user = this.authService.getUser;
    const headers: Record<string, string> = {};
    if (user?.accessToken) {
      headers["xaccesstoken"] = user.accessToken;
    }
    const options = { responseType: 'blob' as const, headers };
    if (env == "dev")
      return this.httpClient.post(`${environment.chatAPi}/download_csv`, data, options);
    else
      return this.httpClient.post(`${environment.uatchatAPI}/download_csv`, data, options);
  }
}
